export function OnboardingRoute() {
  return null
}
